import axios from "axios";

import { API } from "../../backend";
import authHeader from "../auth-header"

const getTransactiontype = () => {
    return axios.get(API + "accounting/transactiontypesgetview/",{headers: authHeader(),});
  };

  const getaccountcode = () => {
    return axios.get(API + "accounting/accountcodeview/",{headers: authHeader(),});
  };
  const createaccountcode = (
  transaction_type,
  product_type,
  account_code,
  de_cr_code,
  amount_object,
  amount_column,
  enabled
  ) => {
    return axios.post(API + "accounting/create-accountsetup/",{
        transaction_type,
        product_type,
        account_code,
        de_cr_code,
        amount_object,
        amount_column,
        enabled
    },{headers: authHeader(),});
  };

const GetAccountingService = {
    getTransactiontype,
    getaccountcode,
    createaccountcode,
  };
  export default GetAccountingService;